const HisContact = ({ color }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5832 16.5001C15.5832 16.0139 15.39 15.5475 15.0462 15.2037C14.7024 14.8599 14.2361 14.6667 13.7498 14.6667H8.24984C7.76361 14.6667 7.29729 14.8599 6.95347 15.2037C6.60966 15.5475 6.4165 16.0139 6.4165 16.5001"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4167 3.66675H4.58333C3.57081 3.66675 2.75 4.48756 2.75 5.50008V18.3334C2.75 19.3459 3.57081 20.1667 4.58333 20.1667H17.4167C18.4292 20.1667 19.25 19.3459 19.25 18.3334V5.50008C19.25 4.48756 18.4292 3.66675 17.4167 3.66675Z"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9998 10.9999C12.0124 10.9999 12.8332 10.1791 12.8332 9.16659C12.8332 8.15406 12.0124 7.33325 10.9998 7.33325C9.98732 7.33325 9.1665 8.15406 9.1665 9.16659C9.1665 10.1791 9.98732 10.9999 10.9998 10.9999Z"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3335 1.83325V3.66659"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6665 1.83325V3.66659"
        stroke={strokeColor}
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisContact;
